import { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useFeedback } from '../../hooks/useFeedback';
import { getApiErrorMessage } from '../../utils/apiError';
import '../LoginPage/LoginPage.css';

const RegisterPage = () => {
  const [form, setForm] = useState({
    club_name: '',
    name: '',
    login: '',
    password: '',
    is_pilot: true,
  });
  const { showError, feedbackNode } = useFeedback();
  const { registerClub, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  if (!loading && isAuthenticated) {
    return <Navigate to="/aircraft" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await registerClub(form);
      navigate('/aircraft');
    } catch (err) {
      showError(getApiErrorMessage(err, 'Не удалось зарегистрировать клуб'));
    }
  };

  return (
    <div className="login-page">
      {feedbackNode}
      <div className="login-card">
        <img src="/plane.png" alt="" className="login-icon" />
        <h1>Бортовой Журнал</h1>
        <p className="login-subtitle">Регистрация клуба</p>
        <form onSubmit={handleSubmit}>
          <label className="login-field">
            <span>Клуб</span>
            <input
              type="text"
              placeholder="Название клуба"
              value={form.club_name}
              onChange={(e) => setForm({ ...form, club_name: e.target.value })}
              required
              maxLength={120}
            />
          </label>
          <input
            type="text"
            placeholder="Ваше имя"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Логин"
            value={form.login}
            onChange={(e) => setForm({ ...form, login: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Пароль"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={4}
          />
          <fieldset className="login-field">
            <legend>Вы пилот / собственник доли?</legend>
            <div className="login-choice">
              <label className="login-choice-option">
                <input
                  type="radio"
                  name="is_pilot"
                  checked={form.is_pilot}
                  onChange={() => setForm({ ...form, is_pilot: true })}
                />
                <span>Да — полёты, брони и доли владения</span>
              </label>
              <label className="login-choice-option">
                <input
                  type="radio"
                  name="is_pilot"
                  checked={!form.is_pilot}
                  onChange={() => setForm({ ...form, is_pilot: false })}
                />
                <span>Нет — только управление клубом</span>
              </label>
            </div>
          </fieldset>
          <button type="submit">Создать клуб</button>
        </form>
        <p className="login-footer">
          Уже есть аккаунт? <Link to="/login">Войти</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
